/* eslint-disable */

export default {
  appName: "Ключ здоровья",
  appLink: "/",
  //appLogo: "./logo.png",
};
